/** COPYRIGHT NOTICE
 *
 *  Copyright (C) Vokke.
 *  All Rights Reserved
 *
 *  This file was developed by Vokke and is only to be used by a person or legal
 *  entity when expressly granted a license to do so through written means.
 *
 *  Unauthorized usage, sharing or copying of this file, via any medium is
 *  strictly prohibited. Proprietary and confidential. This license header
 *  is not to be removed.
 *
 */

import { KernelRoute } from "../kernel";
import { AppRouter } from "marionette";
import RouterSessionManagement from "../../domain/controllers/router-session-management";

/**
 * The router
 */
class ClientRouter extends AppRouter {

    /**
     * Duck punch the router to not allow navigating to any portion of the app without being logged in.
     *
     * @param callback {Function} The callback function
     * @param args {Array} Arguments passed from router
     * @param name {String} Route name
     */
    execute (callback, args, name) {
        if (RouterSessionManagement.onRoute()) {
            super.execute(callback, args, name);
        }
    }
}

const Router = new ClientRouter();

/**
 * This method loops through the requireContext. We assume the single exported
 * object is a class of Abstraction.KernelRoute. We check this and if it is, we
 * instantiate it and add the routes to the Router instance above.
 *
 * @param requireContext
 * @returns {Array}
 */
const requireAll = requireContext => {
    return requireContext.keys().map(function(filePath){
        const classType = requireContext(filePath).default;

        if (!classType) {
            throw new Error(`The route defined in ${filePath} does not export a route class.`);
        }

        const routeInstance = new classType();

        if (false === routeInstance instanceof KernelRoute)  {
            throw new Error(`The route defined in ${filePath} does not export a descendant type of KernelRoute`);
        }

        Router.processAppRoutes(routeInstance, routeInstance.getRoutes());
    });
};

/**
 *  Loop through the domain folder and any files that match *.router.js
 *  are autoloaded (as we assume they are routes).
 */
const req = require.context("../../domain/views", true, /^\.\/.*\.route.js/);
requireAll(req);

export default Router;



// WEBPACK FOOTER //
// ./public/kernel/core/router.js